module.exports = __webpack_public_path__ + "static/media/bedOut.1f46b972.png";